import { useState, useEffect } from 'react';
import heroCrmImage from '../../../assets/images/heroCrmImage.jpg';
import backgroundCrm from '../../../assets/images/backgroundCrm.jpg';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={backgroundCrm}
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 pt-24 sm:pt-32 pb-12 sm:pb-20 min-h-screen flex items-center">
        <div className="w-full grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className={`inline-flex items-center space-x-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
            }`}>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-flashlight-line text-sm text-[#00c897]"></i>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white">StackWay CRM</span>
            </div>

            <h1 className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
              Nền tảng CRM & Quản trị vận hành toàn diện cho doanh nghiệp B2B & B2C
            </h1>

            <p className={`text-base sm:text-lg text-white/85 leading-relaxed transition-all duration-1000 delay-400 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
            StackWay CRM là giải pháp CRM thế hệ mới giúp doanh nghiệp quản lý tập trung khách hàng, bán hàng, marketing và chăm sóc khách hàng, đồng thời kết nối chặt chẽ với quản lý dự án – công việc – quy trình trong một hệ thống thống nhất.
            </p>

            <div className={`flex flex-col sm:flex-row gap-3 sm:gap-4 transition-all duration-1000 delay-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
              <button className="group px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-[#06b6d4] to-[#00c897] text-white rounded-lg font-medium hover:shadow-xl transition-all flex items-center justify-center space-x-2 text-sm sm:text-base cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-rocket-line text-lg"></i>
                </div>
                <span>Dùng thử 30 ngày miễn phí</span>
              </button>
              <button className="px-6 sm:px-8 py-3 sm:py-4 bg-transparent border-2 border-white text-white rounded-lg font-medium hover:bg-white/10 transition-all flex items-center justify-center space-x-2 text-sm sm:text-base cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line text-lg"></i>
                </div>
                <span>Xem demo trực tiếp</span>
              </button>
            </div>

            <div className={`flex flex-col sm:flex-row sm:items-center sm:space-x-6 space-y-2 sm:space-y-0 text-xs sm:text-sm text-white/70 transition-all duration-1000 delay-800 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-[#00c897]"></i>
                <span>Không cần thẻ tín dụng</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-check-line text-[#00c897]"></i>
                <span>Hỗ trợ tiếng Việt 24/7</span>
              </div>
            </div>
          </div>

          <div className={`relative hidden md:block transition-all duration-1000 delay-500 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
          }`}>
            <div className="relative">
              <img
                src={heroCrmImage}
                alt="Dashboard"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <span className="text-sm text-white/70">Cuộn xuống</span>
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-down-line text-xl text-white/70"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
